import type { RouteObject } from 'react-router-dom';
import { ROUTE_BIOMARKER_DETAIL } from '../../../../../constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { Page } from './biomarker-detail.page';

export const routeBiomarkerDetail: RouteObject = {
  path: ROUTE_BIOMARKER_DETAIL,
  Component: Page,
  loader: setTitleFromLoader('Biomarker Details'),
};
